import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "bootstrap/dist/css/bootstrap.css";
import "slick-carousel/slick/slick.css";  
import "slick-carousel/slick/slick-theme.css";
// import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./redux/store";




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);